import { render, staticRenderFns } from "./changyishu.vue?vue&type=template&id=48c5f614&scoped=true"
import script from "./changyishu.vue?vue&type=script&lang=js"
export * from "./changyishu.vue?vue&type=script&lang=js"
import style0 from "./changyishu.vue?vue&type=style&index=0&id=48c5f614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c5f614",
  null
  
)

export default component.exports